//
import {queryList, getAddSmParam,
  getUpdateSmParam, getDeleteSmParamList} from './../api';
import { Message } from 'element-ui';
const smParam = {
    namespaced: true,
    state: {
        successCode:200,
        resp:null,
        addSmParamData:null,
        updateSmParamData:null,
        deleteSmParamList:null,
        total:null,
    },
    mutations: {
      QUERY_LIST(state,resp){
            if (resp.code === state.successCode){
              Message({showClose: true, message: resp.msg, type: 'success'});
            }
            state.resp = resp.obj || [];
            state.total = resp.total
        },
      GET_ADD_CLIENT(state, data){
          state.addSmParamData = data
      },
      GET_UPDATE_SMPARAM(state, data){
        state.updateSmParamData = data
      },
      GET_DELETE_CLIENT_LIST(state, data){
        state.deleteSmParamList = data
      },
      GET_INIT_CLIENT_INFO(state,data){
        state.initClientInfo = data;
      }

    },
    actions: {

       async queryList({commit}, obj){
           let resp = await queryList(obj);
           commit('QUERY_LIST', resp);
        },
        async getAddSmParam({commit}, obj){
          let resp = await getAddSmParam(obj);
          commit('GET_ADD_CLIENT', resp);
        },
        async getUpdateSmParam({commit}, obj){
          let resp = await getUpdateSmParam(obj);
          commit('GET_UPDATE_SMPARAM', resp);
        },
        async getDeleteSmParamList({commit}, obj){
        let resp = await getDeleteSmParamList(obj);
        commit('GET_DELETE_CLIENT_LIST', resp);
      },



    }
}

export default smParam



// WEBPACK FOOTER //
// ./src/page/sm/smParam/store/smParam.store.js